import React, { useState } from "react";

import Input from "components/shared/Inputs/Inputs";
import Button from "components/shared/Button/Button";
import Swal from "sweetalert2";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";

const GatewayCadastro = () => {
  let navigate = useNavigate();
  const initialState = {
    ds_nome: "",
    ds_codigo: "",
    tipo: "",
    tel: "",
  };

  const tipoRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  const ds_codigoRegex = /[^a-z A-Z]/gm;

  const [register, setRegister] = useState(initialState);

  const onChangeHandler = (prop) => (event) => {
    setRegister({ ...register, [prop]: event.target.value });
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const errorStyle = "margin-bottom: 0; font-size: 80%;";
    // if (register.ds_codigo.match(ds_codigoRegex) || register.ds_codigo.length < 3) {
    //   Swal.fire({
    //     icon: "warning",
    //     html:
    //       '<p style="margin-bottom: 0;">Digite Um <b>CONTATO</b> Válido</p>' +
    //       `<p style="${errorStyle}">Apenas Letras e Espaços</p>`,
    //   });
    //   return;
    // }

    // if (!register.tipo.match(tipoRegex)) {
    //   Swal.fire({
    //     icon: "warning",
    //     text: "Digite um tipo Válido",
    //   });
    //   return;
    // }

    // if (register.tel.match(/\D/g)) {
    //   Swal.fire({
    //     icon: "warning",
    //     html:
    //       '<p style="margin-bottom: 0;">Digite Um <b>TELEFONE</b> Válido</p>' +
    //       `<p style="${errorStyle}">Apenas NÚMEROS</p>`,
    //   });
    //   return;
    // }

    const body = {
      DS_NOME: register.ds_nome,
      DS_CODIGO: register.ds_codigo,
      TIPO: register.tipo,
    };

    api
      .post("/gateway", body)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Gateway cadastrado!",
        }).then(() => {
          navigate("/configuracao/gateway")
        });
      })
      .catch(function () {
        Swal.fire({
          icon: "warning",
          text: "Confira todos os dados e faça o cadastro completo!",
        });
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <label id="component-title">Cadastrar | Gateway</label>
        <div>
          <Button
            icon="bx bx-left-arrow-circle"
            iconPosition="left"
            primaryColor="#f8f7ff"
            hoverColor="#f8f7ff"
            text="Voltar"
            link="/configuracao/gateway"
            styles={{
              marginLeft: "1.5rem",
              background: "#f8f7ff",
              color: "blue",
            }}
          />
        </div>
        <form className="component-form container" style={{ margin: "0px" }}>
          <div className="container">
            <div className="row">
              <div className="col-6">
                <Input
                  id="fab-register"
                  label="Nome"
                  value={register.ds_nome}
                  onChange={onChangeHandler("ds_nome")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="ds_codigo"
                  label="Codigo"
                  value={register.ds_codigo}
                  onChange={onChangeHandler("ds_codigo")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  id="tipo"
                  label="Tipo"
                  value={register.tipo}
                  onChange={onChangeHandler("tipo")}
                  styles={{ width: "100%" }}
                />
              </div>
            </div>
          
            <div className="row">
              <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
                <Button
                  icon="ti-agenda"
                  text="Cadastrar"
                  action={submitHandler}
                  primaryColor="#5d4ec0"
                  hoverColor="#4eadc0"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default GatewayCadastro;
